'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var debug = require('debug');

var log = Object.assign(debug('libp2p:peer-store:key-book'), {
  error: debug('libp2p:peer-store:key-book:err')
});

var errcode = require('err-code');

var PeerId = require('peer-id');

var Book = require('./book');

var _require = require('../errors'),
    ERR_INVALID_PARAMETERS = _require.codes.ERR_INVALID_PARAMETERS;
/**
 * @typedef {import('./')} PeerStore
 * @typedef {import('libp2p-crypto').PublicKey} PublicKey
 */

/**
 * @extends {Book}
 */


var KeyBook = /*#__PURE__*/function (_Book) {
  _inherits(KeyBook, _Book);

  var _super = _createSuper(KeyBook);

  /**
   * The KeyBook is responsible for keeping the known public keys of a peer.
   *
   * @class
   * @param {PeerStore} peerStore
   */
  function KeyBook(peerStore) {
    var _this;

    _classCallCheck(this, KeyBook);

    _this = _super.call(this, {
      peerStore: peerStore,
      eventName: 'change:pubkey',
      eventProperty: 'pubkey',
      eventTransformer: function eventTransformer(data) {
        return data.pubKey;
      }
    });
    /**
     * Map known peers to their known Public Key.
     *
     * @type {Map<string, PeerId>}
     */

    _this.data = new Map();
    return _this;
  }
  /**
   * Set the Peer public key.
   *
   * @override
   * @param {PeerId} peerId
   * @param {PublicKey} publicKey
   * @returns {KeyBook}
   */


  _createClass(KeyBook, [{
    key: "set",
    value: function set(peerId, publicKey) {
      if (!PeerId.isPeerId(peerId)) {
        log.error('peerId must be an instance of peer-id to store data');
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      var id = peerId.toB58String();
      var recPeerId = this.data.get(id); // If no record available, and this is valid

      if (!recPeerId && publicKey) {
        // This might be unecessary, but we want to store the PeerId
        // to avoid an async operation when reconstructing the PeerId
        peerId.pubKey = publicKey;

        this._setData(peerId, peerId);

        log("stored provided public key for ".concat(id));
      }

      return this;
    }
    /**
     * Get Public key of the given PeerId, if stored.
     *
     * @override
     * @param {PeerId} peerId
     * @returns {PublicKey | undefined}
     */

  }, {
    key: "get",
    value: function get(peerId) {
      if (!PeerId.isPeerId(peerId)) {
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      var rec = this.data.get(peerId.toB58String());
      return rec ? rec.pubKey : undefined;
    }
  }]);

  return KeyBook;
}(Book);

module.exports = KeyBook;